import { Component, ViewChild } from '@angular/core';
import { Api } from 'datatables.net';
import { RegistrationFormService } from '../../services/data/registration-form.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { renderDate, renderEnumTranslated, renderFromId } from '../../utils/data-tables-utils';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SiteService } from '../../services/data/site.service';
import { Site } from '../../models/site';
import { RegistrationFormModalService } from '../create-form-modal/create-form-modal.service';
import { VisitorRegistrationFormHeader } from '../../models/visitor-registration-form-header';
import { VisitorRegistrationFormType } from '../../models/visitor-registration-form-type';
import 'datatables.net-buttons-bs5';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-my-forms-list',
  standalone: true,
  imports: [
    TranslateModule,
    DataTablesModule
  ],
  templateUrl: './my-forms-list.component.html',
  styleUrl: './my-forms-list.component.scss'
})
export class MyFormsListComponent {
  @ViewChild(DataTableDirective)
  dtElement!: DataTableDirective;

  sites: Site[] = [];
  dataTableOptions: any = {};

  constructor(
    private router: Router,
    private siteService: SiteService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private modalService: RegistrationFormModalService,
    private registrationFormService: RegistrationFormService) {
  }

  navigateToForm(form: VisitorRegistrationFormHeader) {
    this.navigateTo(form.id, form.formType);
  }

  navigateTo(formId: string, formType: VisitorRegistrationFormType) {
    if (formType === VisitorRegistrationFormType.BusinessTrip) {
      this.router.navigate(['/form/stv/', formId, {}]);
    } else if (formType === VisitorRegistrationFormType.WorkOnSite) {
      this.router.navigate(['/form/sta/', formId, {}]);
    }
  }

  createNew() {
    this.modalService.showCreateNewRegistrationDialog().subscribe(
      dialogResult => {
        if (dialogResult.result === false || !dialogResult.entity) return;

        this.registrationFormService.createForm(dialogResult.entity).subscribe(
          (createResponse) => {
            this.refresh();
            this.navigateTo(createResponse.id, createResponse.formType);
          }
        );
      }
    )
  }

  refresh(showToast: boolean = false) {
    this.dtElement.dtInstance.then((dtInstance: Api) => {
      dtInstance.ajax.reload();
      if(showToast) {
        this.showToaster('', 'Refreshed');
      }
    });
  }

  showToaster(title: string, message: string) {
    this.toastService.show(title, message, {
      classname: 'bg-success text-light',
      delay: 2000,
      autohide: true,
    });
  }

  ngOnInit(): void {
    this.siteService.sites$.subscribe(
      (sites) => this.sites = sites
    )

    this.dataTableOptions = {
      info: false,
      stateSave: true,
      searching: false,
      ajax: (dataTableParameters: any, callback: any) => {
        this.registrationFormService.getUserActiveForms().subscribe(
          (data) => {
            callback({
              recordsTotal: data.length,
              recordsFiltered: data.length,
              data: data
            });
          }
        )
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        $(row).off('click');
        $(row).on('click', () => { this.navigateToForm(data as VisitorRegistrationFormHeader); });
        return row;
      },
      columns: [
        {
          title: "Site",
          data: "siteId",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderFromId(this.sites, data, type)
        },
        {
          title: "Type",
          data: "formType",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderEnumTranslated(this.translateService, data, type)
        },
        {
          title: "Status",
          data: "formStatus",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderEnumTranslated(this.translateService, data, type)
        },
        {
          title: "Exp. Arrival",
          data: "expectedArrival",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderDate(data, type)
        },
        {
          title: "Exp. Departure",
          data: "expectedDeparture",
          className: "dt-right",
          defaultContent: '',
          render: (data: any, type: string, row: any) => renderDate(data, type)
        }
      ],
      layout: {
        topStart: {
          buttons: [
            {
              text: '<i class="bi bi-arrow-clockwise"></i> Refresh',
              key: '1',
              action: (e: any, dt: any, node: any, config: any) => this.refresh(true)
            },
            'spacer',
            {
              extend: 'colvis',
              text: '<i class="bi bi-layout-three-columns"></i> Columns',
            },
            'spacer',
            {
              extend: 'excel',
              text: '<i class="bi bi-file-earmark-excel"></i> Export to Excel',
            }
          ],
        },
        topEnd: {
          buttons: [
            {
              text: '<i class="bi bi-file-earmark-plus"></i> New...',
              key: '2',
              action: (e: any, dt: any, node: any, config: any) => this.createNew()
            }
          ]
        }
      }
    };
  }
}
